/**
 * M-4 follow-up: the Przebieg tab's pencil must never lead to a dead click.
 * `findEntryById` resolves an activity item's underlying medication,
 * treatment or reminder from whichever list is in scope (patient-wide or
 * visit-only — see `VisitModalActivityTab`); `isEntryKnownMissing` tells
 * whether that list has loaded and genuinely does not hold the id, as
 * opposed to just not having loaded yet. The pencil renders only once we
 * know it will not be a dead click; an already-open edit form for an entry
 * that turns out missing is closed rather than left stale.
 */
export function findEntryById<T extends { id: string }>(
  list: T[] | undefined,
  id: string,
): T | undefined {
  return list?.find((entry) => entry.id === id);
}

export function isEntryKnownMissing(
  list: { id: string }[] | undefined,
  id: string,
): boolean {
  return list !== undefined && !list.some((entry) => entry.id === id);
}
